import axios from 'axios';
import { gerarLista } from './usuarios';
import { history, numberAleatori, paramsApi } from '../../../helpers';
import { loaded, loading, modalAlertaInfo, modalClose, modalAlertaClean } from '../../../layout/redux/layoutActions';
import api from '../../../helpers/api';
import { AddAlert } from "../../../components"


export const getUsuarios = payload => ({
  type: 'GET_USUARIOS',
  payload
})

export const setUsuariosPaginate = payload => ({
  type: 'SET_USUARIOS_PAGINATE',
  payload
})

export const cleanUsuariosPaginate = payload => ({
  type: 'CLEAN_USUARIOS_PAGINATE',
  payload
})

export const getUsuario = payload => ({
  type: 'GET_USUARIO',
  payload
})

export const postUsuario = payload => ({
  type: 'POST_USUARIO',
  payload
})

export const putUsuario = payload => ({
  type: 'PUT_USUARIO',
  payload
})

export const deleteUsuario = payload => ({
  type: 'DELETE_USUARIO',
  payload
})

export const setUsuario = payload => ({
  type: 'SET_USUARIO',
  payload
})

export const cleanUsuario = payload => ({
  type: 'CLEAN_USUARIO',
  payload
})

export const loadUsuarios = payload => ({
  type: 'LOAD_USUARIOS',
  payload
})

export const errorUsuarios = payload => ({
  type: 'ERROR_USUARIOS',
  payload
})

export const listarUsuarios = e => {
  const params = paramsApi(e)
  return (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch(loading())
    api.get(`/Usuario/ListaUsuariosConta${params}`)
    .then(({data}) => {
      dispatch([
        getUsuarios(data),
        loaded()
      ])
    })
    .catch(err => {
        console.error(err, 'salvarMeusDados err');
        if (err.response.data.iderro === 999) {
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[29],
              show: true,
              btnAction: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
              btnClose: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
            })
          )
        };
        dispatch(loaded())
    });
  }
}

export const criarUsuario = (e, nlsPopup) => {
  
  let paramsAcessos = []
e?.permissoes
  .map(p => {
    let permissao = { ...p }

    if (!permissao.podeVisualizar) {
      permissao.podePdcaVer = false
      permissao.podePdcaGerir = false
    }

    if (!permissao.podePdcaVer) {
      permissao.podePdcaGerir = false
    }

    if (!permissao.permissaoEditarProjeto) {
      permissao.podePdcaVer = false
      permissao.podePdcaGerir = false
    }

    return permissao
  })
  .filter(p => p.podeVisualizar || p.podeEditar || p.podePdcaVer || p.podePdcaGerir)
  .map(p => {
    if (p.podeVisualizar) {
      paramsAcessos = [
        ...paramsAcessos,
        {
          tipoConfig: "Projeto",
          valorConfig: String(p.id)
        }
      ]
    }

    if (p.podeEditar) {
      paramsAcessos = [
        ...paramsAcessos,
        {
          tipoConfig: "EditaProjeto",
          valorConfig: String(p.id)
        }
      ]
    }

    if (p.podePdcaVer) {
      paramsAcessos = [
        ...paramsAcessos,
        {
          tipoConfig: "PdcaVer",
          valorConfig: String(p.id)
        }
      ]
    }

    if (p.podePdcaGerir) {
      paramsAcessos = [
        ...paramsAcessos,
        {
          tipoConfig: "PdcaGerir",
          valorConfig: String(p.id)
        }
      ]
    }
  })
  
  const paramsCuston = {
    email: e.email,
    perfilUsuarioId: e.perfil.id,
    acessos: paramsAcessos,
  }
  return dispatch => {
    dispatch(loading())
    api.put(`/Usuario/ConvidaUsuario`, paramsCuston)
    .then(result => {
      dispatch([
        // postUsuario(result.data),
        loaded(),
        AddAlert('success', nlsPopup.mensagens.convidadocomsucesso)
      ])
    })
    .catch(err => {
        console.error(err, 'salvarMeusDados err');
        dispatch(loaded())
        dispatch(modalClose())

        const data = err?.response?.data;

        // se tem um iderro, usa o correspondente
        if (data?.iderro && nlsPopup[data.iderro]) {
          dispatch(modalAlertaInfo({
            ...nlsPopup[data.iderro],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          }));
        } else {
          // se não tem iderro, ou iderro não existe no nlsPopup, mostra mensagem genérica
          dispatch(modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          }));
        }
    });
  }
}

export const editarUsuario = (e, nlsPopup) => {

  const params = {
  userId: String(e.uniqueId),
  idPerfil: e.perfil.id,
  permissoes: e.permissoes.map(p => {
    let permissao = { ...p }

    if (!permissao.podeVisualizar) {
      permissao.podePdcaVer = false
      permissao.podePdcaGerir = false
    }

    if (!permissao.podePdcaVer) {
      permissao.podePdcaGerir = false
    }

    if (!permissao.permissaoEditarProjeto) {
      permissao.podePdcaVer = false
      permissao.podePdcaGerir = false
    }

    return {
      projetoId: permissao.id,
      podeVisualizar: permissao.podeVisualizar ? permissao.podeVisualizar : false,
      podeEditar: permissao.podeEditar ? permissao.podeEditar : false,
      pdcaVer: permissao.podePdcaVer ? permissao.podePdcaVer : false,
      pdcaGerir: permissao.podePdcaGerir ? permissao.podePdcaGerir : false
    }
  })
}


  return dispatch => {
    dispatch(loading())
    api.put(`/Usuario/EditaUsuario`, params)
    .then(result => {
      dispatch([
        putUsuario(result.data),
        listarUsuarios({ pageNumber: 1, perPage: 7 }), //ADIÇÃO PARA ATUALIZAR O PERFIL APÓS EDIÇÃO
        loaded(),
        AddAlert('success', nlsPopup.mensagens.editadocomsucesso),
        modalAlertaClean()
      ])
    })
    .catch(err => {
        console.error(err, 'salvarMeusDados err');
        dispatch(loaded())
    });
  }
}

export const removerUsuario = e => {
  const params = paramsApi(e)
  return dispatch => {
    dispatch(loading())
    api.put(`/Usuario/DeletaUsuario${params}`)
    .then(result => {
      dispatch([
        deleteUsuario(e),
        loaded()
      ])
    })
    .catch(err => {
        console.error(err, 'salvarMeusDados err');
        dispatch(loaded())
    });
  }
}



